


































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {ErrorResponse, FormField, RegisterUserRequest} from "../../../../types";

@Component({
    components: {},
    props: {}
})

/**
 * Регистрация пользователей
 */
export default class Registration extends Vue {

    private successRegistration: boolean = false;

    private formFields: Array<string> = [
        'email',
        'nickname',
        'is_adult',
        'first_name',
        'last_name',
        'password',
        'password_confirmation',
    ];

    private email: FormField = {
        id: 'email',
        name: 'email',
        type: 'text',
        label: '',
        value: '',
        success: true,
        error: null,
        placeholder: 'Введите Email',
    };

    private nickname: FormField = {
        id: 'nickname',
        name: 'nickname',
        type: 'text',
        label: '',
        value: '',
        success: true,
        error: null,
        placeholder: 'Введите игровое имя',
    };

    private is_adult: FormField = {
        id: 'is_adult',
        type: 'checkbox',
        name: 'is_adult',
        value: '',
        label: '',
        error: null,
        success: false,
        placeholder: '',
    };

    private first_name: FormField = {
        id: 'first_name',
        type: 'text',
        name: 'first_name',
        value: '',
        label: '',
        error: null,
        success: false,
        placeholder: 'Введите имя',
    };

    private last_name: FormField = {
        id: 'last_name',
        type: 'text',
        name: 'last_name',
        value: '',
        label: '',
        error: null,
        success: false,
        placeholder: 'Введите фамилию',
    };

    private password: FormField = {
        id: 'password',
        type: 'password',
        name: 'password',
        value: '',
        label: '',
        error: null,
        success: false,
        placeholder: 'Введите пароль',
    };

    private password_confirmation: FormField = {
        id: 'password_confirmation',
        type: 'password',
        name: 'password_confirmation',
        value: '',
        label: '',
        error: null,
        success: false,
        placeholder: 'Подтвердите пароль',
    };

    /**
     * Отправка формы
     */
    private submitForm(): void
    {
        const params: RegisterUserRequest = {
            email: this.email.value as string,
            nickname: this.nickname.value as string,
            is_adult: !!this.is_adult.value,
            first_name: this.first_name.value as string,
            last_name: this.last_name.value as string,
            password: this.password.value as string,
            password_confirmation: this.password_confirmation.value as string,
        };

        this.$userAuthApi.registerUserRequest(params).then((response: any) => {
            if (response.success) {
                this.successRegistration = true;
            }
        }).catch((error: ErrorResponse) => {
            if (error.code === this.$errorApi.ERROR_VALIDATION) {
                this.clearValidationErrors();
                this.showValidationErrors(error.message);
            }
        });
    }

    /**
     * Очищает ошибки валидации
     */
    private clearValidationErrors(): void
    {
        this.formFields.forEach((fieldProperty) => {
            const field: FormField = (this as any)[fieldProperty];
            field.error = null;
        });
    }

    /**
     * Показать ошибки валидации
     */
    private showValidationErrors(errors: any)
    {
        this.formFields.forEach((fieldProperty) => {
            const field: FormField = (this as any)[fieldProperty];
            field.success = true;

            for (let attribute in errors) {
                if (errors[attribute].length > 0 && typeof errors[attribute][0] !== 'undefined') {
                    const errorMessage = errors[attribute][0];
                    if (field.name === attribute) {
                        field.error = errorMessage;
                        field.success = false;
                    }
                }
            }
        });
    }
}
